import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../apiCalls/rtkBaseQuery';
import { LIST_MAGAZINE } from '../../../apiCalls/urls/magazine';
import { GET_LIST } from '../../../apiCalls/urls/common';
export const magazineApi = createApi({
    baseQuery,
    tagTypes: ['magazine'],
    reducerPath: 'magazineApi',
    endpoints: (builder) => ({
        getMagazineList: builder.query({
            query: (bodyData) => ({
                url: LIST_MAGAZINE,
                method: 'POST',
                body: bodyData || {}
            }),
            providesTags: ['magazine'],
            refetchOnMountOrArgChange: true,
        }),
        getList: builder.mutation({
            query: (bodyData) => ({
                url: GET_LIST,
                method: 'POST',
                body: bodyData || {}
            }),
            refetchOnMountOrArgChange: false,
        })
    }),
});

export const {
    useGetMagazineListQuery,
    useGetListMutation
} = magazineApi;